'use client';

import { useState } from 'react';
import {
  EmployerHeroSection,
  EmployerFeaturesSection,
  EmployerBenefitsSection,
} from '../employers';
import { ContactFormDialog } from '../contact';

/**
 * @group Public
 * @summary Employers page component
 * 
 * Page for employers interested in Phila for their employees.
 * Includes contact form dialog for demo requests.
 */
export function EmployersPage() {
  const [isContactDialogOpen, setIsContactDialogOpen] = useState(false);

  const handleRequestDemo = () => {
    setIsContactDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsContactDialogOpen(false);
  };

  return (
    <main className="min-h-screen">
      {/* Hero section with "Request a Demo" CTA */}
      <EmployerHeroSection onRequestDemo={handleRequestDemo} />
      
      {/* Features - Reducing Burnout, Protecting Autonomy */}
      <EmployerFeaturesSection />
      
      {/* Benefits - Portal, Sick Notes, Analytics */}
      <EmployerBenefitsSection />
      
      {/* Contact Form Dialog */}
      <ContactFormDialog
        isOpen={isContactDialogOpen}
        onClose={handleCloseDialog}
        formType="demo"
      />
    </main>
  );
}
